import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {creditLogSubTypeOptions} from "constants/constants";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";

const FeeTypeFilter = ({
    value,
    onChange,
    disabled = false,
    showAllOption = true,
    allowClear = true,
    hideTitle = false,
    marginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation([]);
    const stores = useStore();
    const [subTypesLoading, subTypes] = useFetch({
        fetchFn: stores.companyStore.subTypes.bind(null),
        dependencies: [],
        initialCall: true
    });

    return (
        <React.Fragment>
            {!hideTitle && <h5>Ücret Tipi</h5>}
            <SelectField
                data-testid="feeTypeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                allowClear={allowClear}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="feeTypeSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {subTypes?.map(subType => (
                    <SelectField.Option
                        key={subType?.value}
                        value={subType?.value}
                        data-testid="feeTypeSelect_option"
                    >
                        {subType?.label}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default FeeTypeFilter;
